import request from '@/utils/http';
// 明细列查询
export const getAdjustDetailList = (params) => {
    return request({
        url: `/api-tms/algorithm/lineDetailCost/detail`,
        method: 'post',
        data: params
    });
};
// 车次调整明细查看
export const adjustRecord = (params) => {
    return request({
        url: `/api-tms/line/detail/adjust/record/query`,
        method: 'post',
        data: params
    });
};
// 主列表数据
export const getLineData = (params) => {
    return request({
        url: `/api-tms/algorithm/lineDetailCost/page`,
        method: 'post',
        data: params
    });
};
// 调整明细，车次订单明细
export const getOrderDetail = (params) => {
    return request({
        url: `/api-tms/algorithm/lineDetailCost/detail/order`,
        method: 'get',
        params: params
    });
};
// 车次调整预览
export const getCarDetail = (params) => {
    return request({
        url: `/api-tms/algorithm/lineDetailCost/detailWithOrder`,
        method: 'get',
        params: params
    });
};
